import { render, staticRenderFns } from "./WriterPage.vue?vue&type=template&id=cd5aff72&scoped=true&"
import script from "./WriterPage.vue?vue&type=script&lang=js&"
export * from "./WriterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5aff72",
  null
  
)

export default component.exports